<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
      element-loading-text=""
      element-loading-spinner="load-style"
      element-loading-background="rgba(170,170,170,0)"
    >
      <lcl-search-bar
        :is-show-created-by="true"
        :is-show-sale-state="true"
        :is-query="true"
        :is-query-price="true"
        :show-currency="true"
        :show-price-no="true"
        :is-surcharge="true"
        :filter="filter"
        @onLevelChanged="onLevelChanged"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
        @onGridRefresh="gridRefresh"
      >
        <template slot="operations">
          <el-button type="primary" @click="onQuatotion()">{{ $t('Pricing.Quotation') }}</el-button>
          <el-button type="primary" @click="exportToExcel()">{{ $t('Pricing.Export') }}</el-button>
        </template>
      </lcl-search-bar>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="23140101"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
    <subscribe-dialog :visible="subscribe.visible" @close="onSubscribeClose" />
    <price-dialog
      :is-fcl="false"
      :visible="priceDialog.visible"
      :price="priceDialog.price"
      :level="priceDialog.level"
      @close="onPriceDialogClose"
    />
  </div>
</template>

<script>
import {
  queryOpenPriceLcls,
  queryByPriceNo
} from '@/api/price/priceLcl'
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import SubscribeDialog from './SubscribeDialog'
import PriceDialog from './PriceDialog'
import StrUtils from '@/utils/StrUtils'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import DateUtils from '@/utils/dateUtils'
import LclSearchBar from '@/components/Cargo/Common/lclSearchBar'
import { exportExcel } from '@/utils/tableDataExportUtils'

export default {
  name: 'LclRealList',
  components: {
    LclSearchBar,
    PriceDialog,
    SubscribeDialog
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: () => false }, // 禁用
    isShowCreatedBy: { type: Boolean, default: true }, // 是否显示录入人
    isManageModule: { type: Boolean, default: false },
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    isShowContractNo: { type: Boolean, default: false },
    showPriceNo: { type: Boolean, default: false }
  },
  data() {
    return {
      URL,
      rowData: [],
      proxy: {},
      showLevel: false, // 是否显示运价等级
      authedLevel: 99,
      txtRemarks: '',
      remarkChange: false,
      targetLevel: 0,
      tenantUtil: null,
      filter: {
        total: 0,
        pol: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        txtBookingAgent: '',
        contractNo: '',
        level: '',
        currency: 'USD',
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: '',
        direct: false,
        frequency1: false,
        frequency2: false,
        frequency3: false,
        frequency4: false,
        frequency5: false,
        frequency6: false,
        frequency7: false
      },
      filterJson: {},
      showDetail: false,
      keyWords: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onRowClickedEvent
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200,
          tooltipValueGetter: (params) => {
            return PriceUtils.priceNoTipFunc(params.data, this.tenantUtil)
          } },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        { headerName: this.$t('Pricing.PriceState'), field: 'priceState', colId: 'priceState', width: 70,
          cellRenderer: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.PriceTrend'), field: 'trend', colId: 'trend', width: 80,
          cellRenderer: (params) => {
            return PriceUtils.trendLabelFunc(params.value)
          } },
        {
          headerName: this.$t('Pricing.CabinNature'), field: 'share', colId: 'share', width: 80,
          cellRenderer: (params) => {
            return PriceUtils.shareColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.RateGrade'), field: 'gradeMin', colId: 'gradeMin', width: 70,
          cellRenderer: (params) => {
            return PriceUtils.gradeMinLabelFunc(params)
          }
        },
        {
          headerName: this.$t('Pricing.EqType'), field: 'eqType', colId: 'eqType', width: 60
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(TON)', field: 'costWeightPrice', colId: 'costWeightPrice', width: 85,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CostPrice') + '(CBM)', field: 'costVolumePrice', colId: 'costVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(TON)', field: 'oneWeightPrice', colId: 'oneWeightPrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.ColoaderPrice') + '(CBM)', field: 'oneVolumePrice', colId: 'oneVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(TON)', field: 'twoWeightPrice', colId: 'twoWeightPrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.CustomerPrice') + '(CBM)', field: 'twoVolumePrice', colId: 'twoVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(TON)', field: 'threeWeightPrice', colId: 'threeWeightPrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.MarketPrice') + '(CBM)', field: 'threeVolumePrice', colId: 'threeVolumePrice', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.priceColumnLabelFunc_nolimit(params.value)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          }
        },
        {
          headerName: this.$t('Pricing.VAT'), field: 'sellVat', colId: 'sellVat', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.vatLabelFunc(params.data, params.value, this.targetLevel)
          }
        },
        {
          headerName: this.$t('Pricing.PaymentTerm'), field: 'term', colId: 'term', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.dataGridColumnPaymentFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.ShippingLine'), field: 'shippingLine', colId: 'shippingLine', width: 200 },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.carrierLabFunc(params.data, params.value)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.carrierTipFunc(params.data)
          }
        },
        { headerName: this.$t('Pricing.Source'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.bookingAgentLabelFunc(params.data, params.value, this.tenantUtil)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, this.language)
          } },
        { headerName: this.$t('Pricing.DepartureDay'), field: 'frequency8', colId: 'frequency8', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
          } },
        {
          headerName: this.$t('Pricing.ClosingDay'), field: 'closingDay', colId: 'closingDay', width: 200
        },
        {
          headerName: this.$t('Pricing.DaysColSea'), field: 'days', colId: 'days', width: 200
        },
        {
          headerName: this.$t('Pricing.ShareCarriers'), field: 'shareCarrier', colId: 'shareCarrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.moreCompanyLabelFun(params.value, 'shortName', 'cmpIdx')
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.shareCarrierTipFunc(params.data)
          }
        },
        {
          headerName: this.$t('Pricing.PodRegion'), field: 'podRegion', colId: 'podRegion', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.podRegionLabFunc(params.data.pod)
          }
        },
        {
          headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.value)
          } },
        { headerName: this.$t('Pricing.customSpecs'), field: 'customSpecs', colId: 'customSpecs', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } }],
      subscribe: {
        visible: false
      },
      priceDialog: {
        visible: false,
        level: 99,
        price: null
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      this.authedLevel = this.getAuthedLevel()
    },
    fetchOrderRequirement() {
    },
    getAuthedLevel() {
      if (this.$checkPermission(['PLDA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PLDA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PLDA_*_2'])) {
        return 2
      }
      return 99
    },
    // 查询
    toSimpleQuery(data) {
      this.proxy = data
      queryByPriceNo(this.proxy).then((res) => {
        this.rowData = res.data
        if (this.rowData && this.rowData.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
        }
        this.loadingEnd()
      }).catch(() => {
        this.loadingEnd()
      })
    },
    handleQueryData(res) {
      const _resMap = res.data
      this.loadingEnd()
      const isNoRecord = !(_resMap)
      if (isNoRecord || _resMap.hasOwnProperty('Count') && Number(_resMap['Count']) === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.rowData = []
        return
      }
      const count = Number(_resMap['Count'][0])
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
      }
      let tenantId = NaN
      let rs = []
      for (const item in _resMap) {
        if (item.indexOf('PL') === 0) {
          tenantId = Number(item.substr(2))
          const rs_tenant = this.getResultsByTenant(_resMap[item], tenantId)
          if (rs_tenant && rs_tenant.length > 0) {
            PriceUtils.recordTenant(rs_tenant, tenantId)
            rs = rs.concat(rs_tenant)
          }
        }
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        rs.pop()
      }
      this.rowData = rs
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.txtRemarks = ''
      this.fullscreenLoading.close()
    },
    getResultsByTenant(map) {
      let rs = []
      const type = 'R'
      if (map.hasOwnProperty(type)) {
        rs = map[type]
      }
      return rs
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.fullscreenLoading = getLoading()
      queryOpenPriceLcls(this.proxy).then((res) => { this.handleQueryData(res) }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    onQuatotion() {
    },
    onSubscribe() {
      this.subscribe.visible = true
    },
    onSubscribeClose() {
      this.subscribe.visible = false
    },
    onPriceDialogClose() {
      this.priceDialog.visible = false
      this.priceDialog.data = {}
    },
    onLevelChanged(level) {
      this.targetLevel = level
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    onRowDoubleClicked(e) {
      console.log('rowclick')
      const data = e.data
      const { showLevel, filter, authedLevel, targetLevel, priceDialog } = this
      if (data) {
        if (showLevel && filter.level && filter.level === '0') {
          if (authedLevel > targetLevel) {
            this.$message.warn(this.$t('Price.YourPermissionIsNotEnough'))
            priceDialog.visible = false
            return
          }
        }
        priceDialog.level = showLevel ? targetLevel : authedLevel === 0 ? 1 : authedLevel
        priceDialog.price = data
        priceDialog.visible = true
      }
    },
    onTxtRemarksDoubleClick() {
      console.log('txtRemarks', this.$refs.txtRemark)
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.txtRemarks = data.remarks + '\n' + this.$t('Message.ShippingSchedule') + ' ' + PriceUtils.frequencyLabelFunc(data, 'frequency') + '  ' + this.$t('Message.Voyage') + ' ' + data.days
    },
    gridRefresh() {
      this.gridOptions.api.refreshCells({ force: true })
    },
    exportToExcel() {
      const fileName = PriceUtils.getFileName('PriceLCL')
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const rows = selectedRows.length === 0 ? this.rowData : selectedRows
      if (rows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, [...allDisplayedColumns])
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

